import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { AccessTypeSidePanel } from "./AccessTypeSidePanel";
import { getGuestlistAccessTypeText } from "utilities/enumutils";
import { Message } from "semantic-ui-react";

interface AccessTypesListProps {
  accessTypes: server.dto.GuestlistAccessType[]
  guestlistId: number
}

export const AccessTypesList = (props: AccessTypesListProps) => {
  return <div className="flex-column gap">
    {props.accessTypes.length === 0 && <Message color="purple">{RESX.GuestlistErrors.AddAtLeast1AccessType}</Message>}
    {props.accessTypes.map(at => <SmallDetails
      key={at.guestlistAccessTypeId}
      label={<AccessTypeSidePanel
        accessType={at}
        trigger={<a>{getGuestlistAccessTypeText(at)}</a>}
      />}
      subLabel={RESX.Guestlist.PlaceCapacity.replace("{0}", at.quantity.toString())}
    />)}
  </div>
}